<template>
    <div>
        <div class="PatchBaselineConfiguration-title">
            <div>
                <Breadcrumb>
                    <BreadcrumbItem to="/patchManagement/policies">{{$t('PatchEasy.PatchPolicy.title')}}</BreadcrumbItem>
                    <BreadcrumbItem>{{$t('PatchEasy.PatchPolicy.patchstdConfig')}}</BreadcrumbItem>
                </Breadcrumb>
            </div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['patchManagement:patchBaselineConfiguration:add_patch_baseline']">{{$t('PatchEasy.PatchPolicy.addStdConfig')}}</Button>
                <add-or-update-patch-baseline v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-patch-baseline>
            </div>
        </div>
        <template>
            <Tabs size="small">
                <TabPane :label="$t('patch_management.patch_policy.patchBaseline')">
                    <div class="PatchBaselineConfiguration-top">
                        <patch-baseline-search></patch-baseline-search>
                    </div>
                    <table-patch-baseline></table-patch-baseline>
                </TabPane>
                <TabPane :label="$t('patch_management.patch_policy.patch')">
                    <div class="PatchBaselineConfiguration-top">
                        <patch-search></patch-search>
                    </div>
                    <table-patch></table-patch>
                </TabPane>
            </Tabs>
        </template>
    </div>
</template>

<script>
    import PatchSearch from '../patch_baseline_configuration/PatchSearch'
    import PatchBaselineSearch from '../patch_baseline_configuration/PatchBaselineSearch'
    import TablePatchBaseline from '../patch_baseline_configuration/TablePatchBaseline'
    import TablePatch from '../patch_baseline_configuration/TablePatch'
    import AddOrUpdatePatchBaseline from '../patch_baseline_configuration/AddOrUpdatePatchBaseline'

    export default {
        name: 'ElasticBlockStoreMonitor',
        components: {
            PatchSearch,
            PatchBaselineSearch,
            TablePatch,
            TablePatchBaseline,
            AddOrUpdatePatchBaseline
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
        methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>

<style scoped>
    .PatchBaselineConfiguration-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .PatchBaselineConfiguration-title>div:nth-child(1)
    {
        float:left;
    }
    .PatchBaselineConfiguration-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .PatchBaselineConfiguration-top
    {
        width: 100%;
    }
    .ivu-breadcrumb {
        font-size: 13px;
        font-weight: 600;
        color: #515a6e;
    }
</style>



// WEBPACK FOOTER //
// src/components/patch_management/policy/patch_baseline_configuration/PatchBaselineConfiguration.vue